module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back kaoji-box",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 .2rem .2rem 0",
      "text-align": "right"
    }
  }, [_c('van-button', {
    on: {
      "click": _vm.unbind
    }
  }, [_vm._v("解绑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "kaoji-title"
  }, [_vm._v(_vm._s(_vm.row.danwei) + _vm._s(_vm.row.kaojitype))]), _vm._v(" "), _c('van-cell-group', [_c('div', {
    staticClass: "kaoji-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.row.zhizhao_pic_url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "考级单位名称",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "考级单位级别",
      "value": _vm.row.kaojitype
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "考级单位地址",
      "value": _vm.row.address
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "客服电话",
      "value": _vm.row.contactsphone
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'QcxjDetailInfo',
        query: {
          status: 1
        }
      }),
      expression: "{name: 'QcxjDetailInfo', query: {status: 1}}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("资讯\n    ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.toKaoji
    }
  }, [_vm._v("考级\n    ")])], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11b3505a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/QcxjDetailMine.vue
// module id = 1322
// module chunks = 0